const productName = process.env.VUE_APP_PRODUCT_NAME
const routes = [
    {
        path: '/home',
        name: 'portal-home',
        component: () => import('@/app/portals/home/'+productName+'/Main.vue'),
        redirect: {
            name: 'portal-home-profile',
        },
        children: [
            {
                path: 'profile',
                name: 'portal-home-profile',
                component: () => import('@/app/portals/home/' + productName +'/Home.vue'),
            },
            /*{
                path: 'login',
                name: 'portal-home-login',
                component: () => import('@/app/portals/home/' + productName +'/Login.vue'),
            },
            {
                path: 'signup',
                name: 'portal-home-signup',
                component: () => import('@/app/portals/home/' + productName +'/Signup.vue'),
            },*/
            {
                path: 'successful-payment',
                name: 'portal-home-successful-payment',
                component: () => import('@/app/portals/home/' + productName +'/SuccessfulPayment.vue'),
            },
            {
                path: 'renewal-successful-payment',
                name: 'portal-home-renewal-successful-payment',
                component: () => import('@/app/portals/home/' + productName +'/RenewalSuccessfulPayment.vue'),
            },
            {
                path: 'confirm-account',
                name: 'portal-home-confirm-account',
                component: () => import('@/app/portals/home/' + productName +'/ConfirmAccount.vue'),
            }
        ]
    }
]

export default routes
